<template>
  <router-view />
</template>

<script setup>
import { onMounted } from "vue";
onMounted(() => {
});
</script>
<style lang="scss"></style>
